const Option = {
  nzSetting: {
    CROP: {
      type: 'CROP',
      name: '农作物',
      list: [
        { text: '玉米', value: '1' },
        { text: '花生', value: '2' },
        { text: '水稻', value: '3' },
        { text: '大豆', value: '4' },
        { text: '小麦', value: '5' },
        { text: '马铃薯', value: '6' },
        { text: '甜菜', value: '8' },
        { text: '油菜', value: '9' },
        { text: '水飞蓟', value: '10' },
        { text: '其他', value: '11' },
        { text: '向日葵', value: '12' },
        { text: '藜麦', value: '13' },
        { text: '燕麦', value: '14' },
        { text: '中草药材', value: '15' }
      ]
    },
    SEED_VARIETY: {
      type: 'SEED_VARIETY',
      name: '种子品种',
      list: [
        { text: '京科968', value: '1' },
        { text: '先玉335', value: '2' }
      ]
    },
    FERTILIZER_BRAND: {
      type: 'FERTILIZER_BRAND',
      name: '肥料品牌',
      list: [
        { text: '嘉施利', value: '1' },
        { text: '云天化', value: '2' }
      ]
    },
    PESTICIDE_BRAND: {
      type: 'PESTICIDE_BRAND',
      name: '农药品牌',
      list: [
        { text: '安道麦', value: '1' },
        { text: '扬农', value: '2' }
      ]
    },
    IRRIGATION_STATUS: {
      type: 'IRRIGATION_STATUS',
      name: '灌溉情况',
      list: [
        { text: '无灌溉', value: '1' },
        { text: '有灌溉', value: '2' }
      ]
    },
    MATURITY_PERIOD: {
      type: 'MATURITY_PERIOD',
      name: '成熟期',
      list: [
        { text: '128', value: '1' },
        { text: '119', value: '2' }
      ]
    },
    // 险种信息：
    INSURANCE_TYPE: {
      type: 'INSURANCE_TYPE',
      name: '险种信息',
      list: [
        { text: '大豆', value: '1' },
        { text: '马铃薯', value: '2' },
        { text: '水稻', value: '3' },
        { text: '玉米制种', value: '4' },
        { text: '向日葵', value: '5' },
        { text: '水地小麦', value: '6' },
        { text: '旱地玉米', value: '7' },
        { text: '水地玉米', value: '8' },
        { text: '甜菜', value: '9' },
        { text: '气象指数', value: '10' },
        { text: '玉米', value: '11' },
        { text: '花生', value: '12' }
      ]
    }
  },
  getTextByValue (type, value) {
    const category = this.nzSetting[type];
    if (!category) {
      throw new Error(`Unknown type: ${type}`);
    }
    const item = category.list.find(item => item.value === value);
    return item ? item.text : '';
  }
};

export default Option;
